/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventDto } from '../../models/workflow-trigger-event-dto';

export interface AutomatedProcessGetTriggerEventById$Params {
  id: number;
}

export function automatedProcessGetTriggerEventById(http: HttpClient, rootUrl: string, params: AutomatedProcessGetTriggerEventById$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetTriggerEventById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowTriggerEventDto>;
    })
  );
}

automatedProcessGetTriggerEventById.PATH = '/automated-process/workflow-trigger/trigger-event/{id}';